import { COMPLETE_BOOKING_GOLF, COMPLETE_BOOKING_GOLF_SUCCESS, COMPLETE_BOOKING_GOLF_ERROR, COMPLETE_BOOKING_GOLF_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CompleteBookingGolf = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETE_BOOKING_GOLF:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case COMPLETE_BOOKING_GOLF_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case COMPLETE_BOOKING_GOLF_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case COMPLETE_BOOKING_GOLF_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CompleteBookingGolf;
